export interface PatchNote {
  version: string;
  date: string;
  changes: string[];
}

export const PATCH_NOTES: PatchNote[] = [
  {
    version: '0.4.3',
    date: 'March 2026',
    changes: [
      'Dedicated profile page with password change',
      'Admin panel for player management',
      'Role-based access control system',
      'User dropdown menu with navigation',
    ],
  },
  {
    version: '0.4.2',
    date: 'March 2026',
    changes: [
      'Stable session persistence across navigation',
      'Clear Guest / Player / Admin user states',
      'Route protection for profile and admin pages',
      'Landing page sign-in prompt for guests',
      'Removed auto-generated Player nicknames',
    ],
  },
  {
    version: '0.4.2',
    date: 'March 2026',
    changes: [
      'Best win streak tracking added to profile',
      'Nickname validation: 3–15 chars, alphanumeric + underscore',
      'Login prompt cooldown after dismissal (3 matches)',
    ],
  },
  {
    version: '0.4.1',
    date: 'March 2026',
    changes: [
      'Profile accessible from username click',
      'Login prompts improved for guests',
      'Leaderboard navigation added to all screens',
      'Guest banner on leaderboard',
      'Multi-match guest conversion prompt',
    ],
  },
  {
    version: '0.4',
    date: 'March 2026',
    changes: [
      'Accounts & leaderboard added',
      'Google Sign-In support',
      'Music upgraded to OGG with crossfade',
      'Scrollable patch history',
      'Profile stats tracking',
    ],
  },
  {
    version: '0.3',
    date: 'March 2026',
    changes: [
      'Background ambient music added',
      'Landing page intro track',
      'Randomized looping music during gameplay',
      'Return to landing page button added to play menu',
    ],
  },
  {
    version: '0.2',
    date: 'March 2026',
    changes: [
      'Multiplayer room validation improved',
      'Accuracy calculation corrected',
      'Ammo feedback added',
      'Stability improvements',
    ],
  },
  {
    version: '0.1',
    date: 'March 2026',
    changes: [
      'Initial release',
      'Singleplayer and multiplayer duels',
      'Western-themed pixel art',
      'Sound effects and wind ambience',
    ],
  },
];
